import { render } from "./ConfirmPopup.vue?vue&type=template&id=4ff122f8"
import script from "./ConfirmPopup.vue?vue&type=script&lang=js"
export * from "./ConfirmPopup.vue?vue&type=script&lang=js"

import exportComponent from "E:\\DeepakKumarJha\\TfsProjects\\BeeNeeGit\\CompStoreFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__